export const SIZES = {
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl',
} as const;
